(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travelovers-tulum-guide-completa"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.travelovers-tulum-guide-portal .tvg');
  if(!root)return;

  var buttons=root.querySelectorAll('[data-business-filter]');
  var cards=root.querySelectorAll('[data-business-card]');
  document.addEventListener('travelovers:businesses-updated',function(){
    deduplicateBusinessCards();
  });
  var empty=root.querySelector('[data-business-empty]');
  var searchForm=root.querySelector('[data-guide-search]');
  var searchInput=root.querySelector('[data-guide-search-input]');
  var feedback=root.querySelector('[data-guide-search-feedback]');
  var businessSection=root.querySelector('#negocios');

  function normalize(value){
    return (value||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
  }

  function businessKey(card){
    var heading=card.querySelector('h3');
    var name=normalize(heading?heading.textContent:'')
      .replace(/&/g,' y ')
      .replace(/[^a-z0-9]+/g,' ')
      .replace(/\s+/g,' ')
      .trim();

    if(name.indexOf('hotel casa tortuga')!==-1)return 'hotel-casa-tortuga';
    if(name.indexOf('casa tortuga')!==-1)return 'cenotes-casa-tortuga';
    if(name.indexOf('camello')!==-1)return 'el-camello-jr';
    if(name.indexOf('pocna')!==-1)return 'hotel-pocna';

    return name.replace(/\btulum\b/g,'').replace(/\s+/g,' ').trim();
  }

  function deduplicateBusinessCards(){
    var seen={};
    root.querySelectorAll('[data-business-card]').forEach(function(card){
      var key=businessKey(card);
      if(key&&seen[key]){
        card.remove();
      }else if(key){
        seen[key]=true;
      }
    });
    cards=root.querySelectorAll('[data-business-card]');
  }

  deduplicateBusinessCards();

  function setFeedback(message){
    if(!feedback)return;
    feedback.textContent=message||'';
    feedback.hidden=!message;
  }

  function markActive(value){
    buttons.forEach(function(button){
      button.classList.toggle('is-active',button.dataset.businessFilter===value);
    });
  }

  function filter(value){
    var visible=0;
    cards.forEach(function(card){
      var organizations=' '+(card.dataset.organizations||'')+' ';
      var organizationMatch=organizations.indexOf(' '+value+' ')!==-1;
      var show=value==='all'||card.dataset.category===value||organizationMatch;
      card.hidden=!show;
      if(show)visible++;
    });
    markActive(value);
    if(empty)empty.hidden=visible!==0;
    return visible;
  }

  function findBusinesses(query,titleOnly){
    var visible=0;
    cards.forEach(function(card){
      var title=card.querySelector('h3');
      var source=titleOnly&&title?title.textContent:(card.dataset.search||card.textContent);
      var show=normalize(source).indexOf(query)!==-1;
      card.hidden=!show;
      if(show)visible++;
    });
    markActive('');
    if(empty)empty.hidden=visible!==0;
    return visible;
  }

  function go(url){
    window.location.href=url;
  }

  buttons.forEach(function(button){
    button.addEventListener('click',function(){
      filter(button.dataset.businessFilter);
      setFeedback('');
    });
  });

  if(searchForm&&searchInput){
    searchForm.addEventListener('submit',function(event){
      event.preventDefault();
      var raw=searchInput.value.trim();
      var query=normalize(raw);
      if(!query){
        setFeedback('Escribe un lugar, negocio, categoría o experiencia.');
        searchInput.focus();
        return;
      }

      var businessMatches=findBusinesses(query,true);
      if(businessMatches>0){
        setFeedback(businessMatches===1?'Encontramos 1 negocio relacionado.':'Encontramos '+businessMatches+' negocios relacionados.');
        businessSection.scrollIntoView({behavior:'smooth',block:'start'});
        return;
      }

      var categories=[
        {terms:['restaurante','restaurantes','comer','comida','mariscos','gastronomia'],value:'restaurantes'},
        {terms:['hotel','hoteles','hospedaje','dormir','glamping'],value:'hospedaje'},
        {terms:['experiencia','experiencias','actividad','actividades','tour','tours'],value:'experiencias'},
        {terms:['transporte','traslado','transfer'],value:'transporte'},
        {terms:['bienestar','spa','yoga','masaje'],value:'bienestar'},
        {terms:['comercio','artesania','compras','tienda'],value:'comercio-local'},
        {terms:['bar','bares','noche','vida nocturna'],value:'vida-nocturna'},
        {terms:['boda','bodas','evento','eventos'],value:'eventos'}
      ];
      for(var i=0;i<categories.length;i++){
        if(categories[i].terms.some(function(term){return query.indexOf(term)!==-1;})){
          var categoryMatches=filter(categories[i].value);
          setFeedback(categoryMatches?'Encontramos '+categoryMatches+' opciones en esta categoría.':'Todavía no hay negocios publicados en esta categoría.');
          businessSection.scrollIntoView({behavior:'smooth',block:'start'});
          return;
        }
      }

      var routes=[
        {terms:['7 dias','siete dias'],url:'/products/tulum-en-7-dias'},
        {terms:['5 dias','cinco dias'],url:'/products/tulum-en-5-dias'},
        {terms:['3 dias','tres dias'],url:'/products/tulum-en-3-dias'},
        {terms:['2 dias','dos dias'],url:'/products/tulum-en-2-dias'},
        {terms:['1 dia','un dia'],url:'/products/tulum-en-1-dia'},
        {terms:['cenote','cenotes','selva','natural'],url:root.dataset.guideCenotesUrl},
        {terms:['playa','playas','caribe','parque del jaguar','jaguar'],url:root.dataset.guideBeachesUrl},
        {terms:['sian kaan','muyil','punta allen','reserva'],url:root.dataset.guideSianKaanUrl},
        {terms:['arqueologia','arqueologica','arqueologico','ruinas','coba','zona maya'],url:root.dataset.guideArchaeologyUrl},
        {terms:['ado','tren maya','aeropuerto','moverme','moverte','movilidad','colectivo','taxi','llegar'],url:root.dataset.guideMobilityUrl},
        {terms:['tulum','aldea zama','zona hotelera','centro','comunidades'],url:root.dataset.guideTulumUrl}
      ];
      for(var j=0;j<routes.length;j++){
        if(routes[j].terms.some(function(term){return query.indexOf(term)!==-1;})){
          go(routes[j].url);
          return;
        }
      }

      var relatedBusinesses=findBusinesses(query,false);
      if(relatedBusinesses>0){
        setFeedback(relatedBusinesses===1?'Encontramos 1 negocio relacionado.':'Encontramos '+relatedBusinesses+' negocios relacionados.');
        businessSection.scrollIntoView({behavior:'smooth',block:'start'});
        return;
      }

      go(root.dataset.guideSearchUrl+'?q='+encodeURIComponent(raw));
    });
  }
})();

(function(){
  var root=document.querySelector('.travelovers-tulum-guide-portal .tvg');
  if(!root)return;

  var directoryGrid=root.querySelector('.tvg__business-grid');
  var businessSection=root.querySelector('#negocios');
  var categoryButtons=root.querySelectorAll('[data-category-filter]');
  var organizationButtons=root.querySelectorAll('[data-organization-filter]');
  var typeSelect=root.querySelector('[data-business-type-select]');
  var sortSelect=root.querySelector('[data-business-sort]');
  var empty=root.querySelector('[data-business-empty]');
  var searchForm=root.querySelector('[data-guide-search]');
  var searchInput=root.querySelector('[data-guide-search-input]');
  var feedback=root.querySelector('[data-guide-search-feedback]');
  var resultsPanel=root.querySelector('[data-search-results]');
  var resultsGrid=root.querySelector('[data-search-results-grid]');
  var resultsTitle=root.querySelector('[data-search-results-title]');
  var clearSearch=root.querySelector('[data-search-clear]');
  var viewAll=root.querySelector('[data-search-view-all]');
  var activeCategory='all';
  var activeOrganization='all';
  var activeQuery='';

  function normalize(value){
    return (value||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
  }

  function getCards(){
    return Array.prototype.slice.call(root.querySelectorAll('.tvg__business-grid [data-business-card]'));
  }

  function titleOf(card){
    var title=card.querySelector('h3');
    return title?title.textContent.trim():'';
  }

  function compareNames(a,b){
    return titleOf(a).localeCompare(titleOf(b),'es',{sensitivity:'base',numeric:true});
  }

  function recentValue(card){
    var raw=(card.dataset.added||'').trim();
    if(/^\d{4}-\d{2}-\d{2}$/.test(raw))return Number(raw.replace(/-/g,''));
    return card.dataset.source==='manual'?1:0;
  }

  function relevanceScore(card,query){
    if(!query)return 0;
    var title=normalize(titleOf(card));
    var category=normalize(card.dataset.category||'');
    var content=normalize(card.dataset.search||card.textContent);
    var words=query.split(/\s+/).filter(Boolean);
    if(title===query)return 1000;
    if(title.indexOf(query)===0)return 800;
    if(title.indexOf(query)!==-1)return 600;
    if(category===query||category.indexOf(query)!==-1)return 400;
    if(words.length&&words.every(function(word){return content.indexOf(word)!==-1;}))return 250+words.length;
    if(content.indexOf(query)!==-1)return 200;
    return 0;
  }

  function sortCards(mode,query){
    var cards=getCards();
    cards.sort(function(a,b){
      if(mode==='recent'){
        var dateDifference=recentValue(b)-recentValue(a);
        if(dateDifference)return dateDifference;
        var sourceA=a.dataset.source==='manual'?1:0;
        var sourceB=b.dataset.source==='manual'?1:0;
        if(sourceB!==sourceA)return sourceB-sourceA;
        var orderA=Number(a.dataset.originalOrder||0);
        var orderB=Number(b.dataset.originalOrder||0);
        return orderB-orderA||compareNames(a,b);
      }
      if(mode==='za')return compareNames(b,a);
      if(mode==='featured'){
        var featuredA=a.dataset.featured==='true'?1:0;
        var featuredB=b.dataset.featured==='true'?1:0;
        return featuredB-featuredA||compareNames(a,b);
      }
      if(mode==='relevance'&&query){
        return relevanceScore(b,query)-relevanceScore(a,query)||compareNames(a,b);
      }
      return compareNames(a,b);
    });
    cards.forEach(function(card){directoryGrid.appendChild(card);});
    return cards;
  }

  function setActiveButtons(buttons,value,attribute){
    buttons.forEach(function(button){
      button.classList.toggle('is-active',button.getAttribute(attribute)===value);
    });
  }

  function applyDirectory(){
    var mode=sortSelect?sortSelect.value:'recent';
    var cards=sortCards(mode,activeQuery);
    var visible=0;
    cards.forEach(function(card){
      var categoryMatch=activeCategory==='all'||card.dataset.category===activeCategory;
      var organizations=' '+(card.dataset.organizations||'')+' ';
      var organizationMatch=activeOrganization==='all'||organizations.indexOf(' '+activeOrganization+' ')!==-1;
      var queryMatch=!activeQuery||relevanceScore(card,activeQuery)>0;
      var show=categoryMatch&&organizationMatch&&queryMatch;
      card.hidden=!show;
      if(show)visible++;
    });
    if(empty)empty.hidden=visible!==0;
    return visible;
  }

  function hideResults(){
    if(resultsPanel)resultsPanel.hidden=true;
    if(resultsGrid)resultsGrid.innerHTML='';
    if(viewAll)viewAll.hidden=true;
  }

  function showSearchResults(query){
    var matches=getCards().filter(function(card){return relevanceScore(card,query)>0;});
    matches.sort(function(a,b){return relevanceScore(b,query)-relevanceScore(a,query)||compareNames(a,b);});
    resultsGrid.innerHTML='';
    matches.slice(0,6).forEach(function(card){
      var clone=card.cloneNode(true);
      clone.hidden=false;
      clone.removeAttribute('data-shopify-editor-block');
      resultsGrid.appendChild(clone);
    });
    resultsTitle.textContent=matches.length===1?'Encontramos 1 opción para ti.':'Encontramos '+matches.length+' opciones para ti.';
    resultsPanel.hidden=false;
    viewAll.hidden=matches.length<=6;
    if(feedback){feedback.textContent=matches.length?'Resultados encontrados debajo del buscador.':'No encontramos negocios con esa búsqueda.';feedback.hidden=false;}
    resultsPanel.scrollIntoView({behavior:'smooth',block:'start'});
    return matches.length;
  }

  categoryButtons.forEach(function(button){
    button.addEventListener('click',function(){
      activeCategory=button.dataset.categoryFilter;
      activeQuery='';
      if(typeSelect)typeSelect.value=activeCategory;
      setActiveButtons(categoryButtons,activeCategory,'data-category-filter');
      hideResults();
      applyDirectory();
    });
  });

  organizationButtons.forEach(function(button){
    button.addEventListener('click',function(){
      activeOrganization=button.dataset.organizationFilter;
      setActiveButtons(organizationButtons,activeOrganization,'data-organization-filter');
      applyDirectory();
    });
  });

  if(typeSelect){
    typeSelect.addEventListener('change',function(){
      activeCategory=typeSelect.value;
      activeQuery='';
      setActiveButtons(categoryButtons,activeCategory,'data-category-filter');
      hideResults();
      applyDirectory();
    });
  }

  if(sortSelect)sortSelect.addEventListener('change',applyDirectory);

  if(searchForm&&searchInput){
    searchForm.addEventListener('submit',function(event){
      event.preventDefault();
      event.stopImmediatePropagation();
      var raw=searchInput.value.trim();
      var query=normalize(raw);
      if(!query){
        if(feedback){feedback.textContent='Escribe un lugar, negocio, categoría o experiencia.';feedback.hidden=false;}
        searchInput.focus();
        return;
      }
      activeQuery=query;
      var total=showSearchResults(query);
      if(total)return;
      var routes=[
        {terms:['7 dias','siete dias'],url:'/products/tulum-en-7-dias'},
        {terms:['5 dias','cinco dias'],url:'/products/tulum-en-5-dias'},
        {terms:['3 dias','tres dias'],url:'/products/tulum-en-3-dias'},
        {terms:['2 dias','dos dias'],url:'/products/tulum-en-2-dias'},
        {terms:['1 dia','un dia'],url:'/products/tulum-en-1-dia'},
        {terms:['cenote','cenotes','selva','natural'],url:root.dataset.guideCenotesUrl},
        {terms:['playa','playas','caribe','parque del jaguar','jaguar'],url:root.dataset.guideBeachesUrl},
        {terms:['sian kaan','muyil','punta allen','reserva'],url:root.dataset.guideSianKaanUrl},
        {terms:['arqueologia','arqueologica','arqueologico','ruinas','coba','zona maya'],url:root.dataset.guideArchaeologyUrl},
        {terms:['ado','tren maya','aeropuerto','movilidad','colectivo','taxi','llegar'],url:root.dataset.guideMobilityUrl}
      ];
      for(var i=0;i<routes.length;i++){
        if(routes[i].terms.some(function(term){return query.indexOf(term)!==-1;})){
          window.location.href=routes[i].url;
          return;
        }
      }
    },true);
  }

  if(viewAll){
    viewAll.addEventListener('click',function(){
      activeCategory='all';
      activeOrganization='all';
      if(typeSelect)typeSelect.value='all';
      if(sortSelect)sortSelect.value='relevance';
      setActiveButtons(categoryButtons,'all','data-category-filter');
      setActiveButtons(organizationButtons,'all','data-organization-filter');
      applyDirectory();
      businessSection.scrollIntoView({behavior:'smooth',block:'start'});
    });
  }

  if(clearSearch){
    clearSearch.addEventListener('click',function(){
      activeQuery='';
      searchInput.value='';
      hideResults();
      if(feedback){feedback.textContent='';feedback.hidden=true;}
      if(sortSelect)sortSelect.value='recent';
      applyDirectory();
      searchInput.focus();
    });
  }

  getCards().forEach(function(card,index){card.dataset.originalOrder=String(index);});
  if(sortSelect)sortSelect.value='recent';
  applyDirectory();
})();

  } catch(e) { console.error(e); }
})();
})();
